<template>
  <div>
    <template v-if="!isPresent(value)"> - </template>
    <template v-else-if="type === FIELD_TYPES.DATE">
      <p class="my-0">{{ toDate(value, "DD/MM/YYYY") }}</p>
    </template>
    <template v-else-if="type === FIELD_TYPES.IMAGE_UPLOAD">
      <img :src="value" />
    </template>
    <template v-else-if="type === FIELD_TYPES.MULTI_SELECT">
      <p v-for="(val, i) in value.split('|')" :key="i" class="mb-1 mt-0">
        {{ val }}
      </p>
    </template>
    <template v-else>
      <p class="my-0">{{ value }}</p>
    </template>
  </div>
</template>

<script>
import { isPresent } from "@/lib/utils"
import { toDate } from "@/lib/date-utils"
import { FIELD_TYPES } from "@/lib/form-utils"

export default {
  props: {
    value: { type: [Number, String], default: null },
    type: { type: String, required: true }
  },

  data() {
    return {
      FIELD_TYPES
    }
  },

  methods: {
    toDate,
    isPresent
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

img {
  width: 100%;
  border-radius: $size--1;
  border-radius: var(--border-radius);
}
</style>
